module.exports = __webpack_public_path__ + "img/76058.00f7eb0a.svg";